import React from 'react'

class ContactsPage extends React.Component {
  render() {
    return (
      <div className="contacts">
        <div className="wd">
          <h1 className="contacts__heading">Контакти</h1>
          <div className="contacts__section">
            <p className="contacts__section__heading"><img src="/img/phone.svg" alt="" />Телефони:</p>
            <div className="contacts__halves">
              <div className="contacts__half"><p>Каса: </p> <p>(067) 329-98-30</p></div>
              <div className="contacts__half"><p>Адмiн: </p><p>(067) 247-59-73</p></div>
            </div>
          </div>
          <div className="contacts__section">
            <p className="contacts__section__heading"><img src="/img/locator.svg" alt="" />Наша адреса:</p>
            <p className="contacts__address">ТОВ "Кіноман"<br />вул. Костянтинівська, 26, Україна, м.Київ, 04071</p>
            <a href="https://goo.gl/maps/Z5LAHUnV4g1LXG119" target="_blank" className="contacts__button">Показати на карті</a>
          </div>
          <div className="contacts__section">
            <p className="contacts__section__heading"><img src="/img/email.svg" alt="" />Email:</p>
            <a href="mailto:ms-kino@zhovten-kino.kyiv.ua" className="contacts__email">ms-kino@zhovten-kino.kyiv.ua</a>
          </div>
          <div className="contacts__section contacts__other">
            <p className="contacts__section__heading">Інші послуги</p>
            <p className="contacts__other__description">З питаннь розміщення реклами, послуг із забезпечення роботи конференцзали, замовлення послуг колективного/індивідуального кіноперегляду, а також організації фуршетів - звертайтеся:</p>
            <div className="contacts__halves">
              <div className="contacts__half"><img src="/img/email.svg" alt="" /><a href="mailto:ms-kino@zhovten-kino.kyiv.ua" className="contacts__other__email">ms-kino@zhovten-kino.kyiv.ua</a></div>
              <div className="contacts__half"><a href="mailto:personal@zhovten-kino.kyiv.ua" className="contacts__other__email">personal@zhovten-kino.kyiv.ua</a></div>
            </div>
          </div>
          <img src="/img/il_contacts.jpg" className="contacts__ill" alt="" />
          <img src="/img/phone1.png" className="contacts__phone1" alt="" />
          <img src="/img/phone2.png" className="contacts__phone2" alt="" />
        </div>
      </div>
    )
  }
}

export default ContactsPage


// WEBPACK FOOTER //
// ./src/components/pages/ContactsPage/ContactsPageWrapper.jsx